module.exports = __webpack_public_path__ + "media/images/pages/blog-028cdf45a22354012afc6918d6d82d11.jpg";